import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

export class ZIDXAccountSuperAdminUsers implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSuperAdminUsersContainer";
    }
    render(){
        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
    }
}